<template>
  <BaseAction>
    <PrimaryButton light dense shrink @click.native="openDialog">
      Edit Self-Schedule Slots
      <template v-slot:append:icon>
        <v-icon class="ml-2">mdi-pencil</v-icon>
      </template>
    </PrimaryButton>
    <EditSelfScheduleInterviewFormatDialog
      :interviewFormat="interviewFormat"
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditSelfScheduleInterviewFormatDialog from "@/views/bookings/BookingInterviews/components/dialogs/EditSelfScheduleInterviewFormatDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "EditSelfScheduleInterviewFormatAction",
  components: {
    EditSelfScheduleInterviewFormatDialog,
    PrimaryButton,
    BaseAction
  },
  props: {
    interviewFormat: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
